<template>
  <UCard :ui="mergedUi">
    <template v-if="title || $slots.header" #header>
      <div
        class="flex items-start sm:items-center justify-between gap-4"
        :class="{ 'cursor-pointer select-none': collapsible }"
        @click="collapsible && (isOpen = !isOpen)"
      >
        <div class="flex flex-col min-w-0">
          <div class="flex items-center gap-2">
            <slot name="header">
              <h3 class="text-base font-semibold truncate">{{ title }}</h3>
            </slot>
          </div>
          <p v-if="description" class="text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-2 sm:line-clamp-none">
            {{ description }}
          </p>
        </div>
        <UButton
          v-if="collapsible"
          :icon="isOpen ? 'i-heroicons-chevron-up' : 'i-heroicons-chevron-down'"
          color="neutral"
          variant="ghost"
          class="shrink-0"
          @click.stop="isOpen = !isOpen"
        />
      </div>
    </template>

    <UCollapsible v-model:open="isOpen">
      <template #content>
        <div :class="[title || $slots.header ? 'pt-0' : '']">
          <slot />
        </div>
      </template>
    </UCollapsible>

    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </UCard>
</template>

<script lang="ts" setup>
import { ref, watch, computed } from 'vue'

const props = defineProps({
  title: String,
  description: String,
  collapsible: {
    type: Boolean,
    default: true,
  },
  defaultOpen: {
    type: Boolean,
    default: false,
  },
  ui: Object,
})

const isOpen = ref(props.defaultOpen)

const mergedUi = computed(() => ({
  ...props.ui,
  root: [props.ui?.root, props.collapsible && !isOpen.value ? 'divide-y-0' : ''].filter(Boolean).join(' '),
  body: [props.ui?.body, props.collapsible && !isOpen.value ? 'hidden' : ''].filter(Boolean).join(' '),
}))

// In case the defaultOpen prop changes (though unlikely to be reactive in most use cases)
watch(
  () => props.defaultOpen,
  (newVal) => {
    isOpen.value = newVal
  },
)
</script>
